import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { X } from "lucide-react";

const Meeting = () => {
  const [params] = useSearchParams();
  const url = params.get("url");
  const nav = useNavigate();

  if (!url) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center p-6 text-center">
        <div>
          <p className="text-sm text-[#78716C] mb-4">Missing meeting link</p>
          <button data-testid="meeting-back" onClick={() => nav("/dashboard")} className="btn-secondary">Back to dashboard</button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[70] bg-black" data-testid="meeting-frame">
      <button data-testid="meeting-close" onClick={() => nav("/dashboard")}
        className="absolute top-5 right-5 z-10 w-10 h-10 rounded-full bg-black/60 backdrop-blur-md text-white flex items-center justify-center">
        <X size={20} />
      </button>
      <iframe
        title="Consultation"
        src={url}
        allow="camera; microphone; fullscreen; speaker; display-capture"
        className="w-full h-full border-0"
      />
    </div>
  );
};

export default Meeting;
